module.exports = __webpack_public_path__ + "img/menu_logo_expand.3b2c4561.png";